import { ReduxActionType } from 'types';

type ActionTypes = {
  FETCH_RESPONSE_ATTACHMENTS_START: ReduxActionType;
  FETCH_RESPONSE_ATTACHMENTS_SUCCESS: ReduxActionType;
  FETCH_RESPONSE_ATTACHMENTS_FAILURE: ReduxActionType;
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START: ReduxActionType;
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_SUCCESS: ReduxActionType;
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_FAILURE: ReduxActionType;
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START: ReduxActionType;
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_SUCCESS: ReduxActionType;
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_FAILURE: ReduxActionType;
};

export const ResponseActionTypes: ActionTypes = {
  FETCH_RESPONSE_ATTACHMENTS_START: '@@FETCH_RESPONSE_ATTACHMENTS_START',
  FETCH_RESPONSE_ATTACHMENTS_SUCCESS: '@@FETCH_RESPONSE_ATTACHMENTS_SUCCESS',
  FETCH_RESPONSE_ATTACHMENTS_FAILURE: '@@FETCH_RESPONSE_ATTACHMENTS_FAILURE',
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START:
    '@@GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_START',
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_SUCCESS:
    '@@GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_SUCCESS',
  GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_FAILURE:
    '@@GET_RESPONSE_ATTACHMENT_DOWNLOAD_LINK_FAILURE',
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START:
    '@@GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_START',
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_SUCCESS:
    '@@GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_SUCCESS',
  GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_FAILURE:
    '@@GET_RESPONSE_ATTACHMENTS_DOWNLOAD_ALL_FAILURE'
};

export interface ResponseState {
  loadingResponseAttachments?: boolean;
  responseAttachmentsData?: any;
  errorResponseAttachments?: any;
  loadingDownloadLink?: boolean;
  downloadLink?: any;
  errorDownloadLink?: any;
  loadingDownloadAll?: boolean;
  downloadAll?: any;
  errorDownloadAll?: any;
}
